import * as _ from 'lodash-es';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, ViewEncapsulation, ChangeDetectionStrategy, inject, viewChild } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { LoaderService } from '../../../services/loader.service';

import { USER_TYPE_CLIENT, USER_TYPE_CPP, USER_TYPE_EXE } from 'src/app/models/usersTypes.model';
import { AuthService } from 'src/app/services/auth.service';
import { User } from 'src/app/models/users.model';
import { LivecoAPIService } from 'src/app/services/liveco-api.service';
import { Marque } from 'src/app/models/marque.model';
import { environment } from 'src/environments/environment';
import { MatDivider } from '@angular/material/divider';
import { NavComponent } from '../nav/nav.component';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

// const api = require('@modules/cf-api.js').api;;

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterLink, MatDivider, NavComponent, NgClass, MatIcon]
})
export class HeaderComponent {
    protected router = inject(Router);
    protected loaderService = inject(LoaderService);
    protected auth = inject(AuthService);
    protected liveco = inject(LivecoAPIService);
    private cd = inject(ChangeDetectorRef);


    readonly containerHeader = viewChild<ElementRef>("containerHeader");
    readonly easydiademHeader = viewChild<ElementRef>("easydiademHeader");

    get loading(): boolean { return this.loaderService.loading; };
    
    get isCpp(): boolean { return this.auth.isCPP(); }
    get isClient(): boolean { return this.auth.isClient(); }
    get isOperator(): boolean { return this.auth.isOperator(); }
    
    get user(): User | null {
        return this.auth.user;
    };

    userTypesExe = USER_TYPE_EXE;
    userTypesCpp = USER_TYPE_CPP;
    userTypesClient = USER_TYPE_CLIENT;
    
    get userFullName(): string {
        return this.user?.fullname || '';
    }
        
    failedLogoUrls = new Set<string>();

    get urlLogoClient(): string[] {
        const brands = this.user?.marques || [];
        const brandLogoVisibility = new Map(
            brands.map((brand: any) => [brand.label, brand?.theme?.showLogoInTopbar !== false])
        );

        const visibleBrands = brands
            .filter((brandLabel: string) => brandLogoVisibility.get(brandLabel) !== false)
       
        return visibleBrands.map(label => `${environment.api.url}/brand-logo/${encodeURIComponent(label)}`);
    }


    get userEasydiadem() {
        return this.auth?.userBrand.some((brand: Marque) => brand?.flags?.easydiadem) || false;
    }

    get clientTopbarBrand(): Marque | undefined {
        if (!this.auth.isClient() || this.auth.userBrand.length !== 1) {
            return undefined;
        }

        return this.auth.userBrand[0];
    }

    get topbarBackgroundColor(): string | null {
        return this.normalizeColor(this.clientTopbarBrand?.theme?.topbarBackground);
    }

    get topbarTextColor(): string | null {
        return this.normalizeColor(this.clientTopbarBrand?.theme?.topbarText);
    }

    get showDiademLogo(): boolean {
        return this.clientTopbarBrand?.theme?.showDiademLogoInTopbar !== false;
    }

    get showTeamCreatifLogo(): boolean {
        return this.clientTopbarBrand?.theme?.showTeamCreatifLogoInTopbar !== false;
    }

    get showBrandLogoPadding(): boolean {
        return this.clientTopbarBrand?.theme?.showLogoPaddingInTopbar !== false;
    }

    logout() {
        this.auth.logout();
    }

    goToEadyDiadem() {
        return '/easydiadem/dashboard';
    }

    easyDiademRoute() {
        return this.router.url.includes('/easydiadem/');
    }

    onLogoError(url: string): void {
        this.failedLogoUrls.add(url);
        this.cd.markForCheck();
    }

    removeFilterDashboard() {
        localStorage.removeItem('liveco-filters-project-dashboard');
    }

    private normalizeColor(color?: string): string | null {
        const value = color?.trim();
        return value ? value : null;
    }
}
